import { Avatar, CustomBadge } from "subframe";
import * as SubframeCore from "@subframe/core";

import {
  getAcronym,
  getFullName,
  isEmpty as isStringEmpty,
} from "utils/string";

const EmployeeSearchResultItemV2 = ({
  id,
  tenure,
  last_name,
  job_title,
  is_active,
  first_name,
  supervisor,
  office_location,
  escalation_status,
  onClick = () => {},
  profile_picture_url,
}) => {
  return (
    <div
      className="flex w-full grow shrink-0 basis-0 items-center gap-3 rounded pt-2 pr-3 pb-2 pl-3 cursor-pointer hover:bg-neutral-50"
      onClick={() => onClick(id)}
    >
      <Avatar size="small" color="Default Inverted">
        {getAcronym(getFullName(first_name, last_name))}
      </Avatar>
      <div
        className={SubframeCore.twClassNames(
          "flex w-full grow shrink-0 basis-0 items-center gap-2"
        )}
      >
        <span
          className={SubframeCore.twClassNames(
            "text-body-bold font-body-bold text-default-font",
            { "text-subtext-color": !is_active }
          )}
        >
          {getFullName(first_name, last_name)}
        </span>
        <span className="text-label font-label text-subtext-color">•</span>
        <span className="text-label font-label text-subtext-color">
          {isStringEmpty(job_title) ? "-" : job_title}
        </span>
        <span className="text-label font-label text-subtext-color">•</span>
        <span className="text-label font-label text-subtext-color">
          {isStringEmpty(office_location) ? "-" : office_location}
        </span>
        <span className="text-label font-label text-subtext-color">•</span>
        <span className="text-label font-label text-subtext-color">
          {isStringEmpty(supervisor) ? "-" : supervisor}
        </span>
        <span className="text-label font-label text-subtext-color">•</span>
        <span className="text-label font-label text-subtext-color">
          {isStringEmpty(tenure) ? "-" : tenure}
        </span>
      </div>
      <CustomBadge
        className={SubframeCore.twClassNames("hidden", {
          flex: escalation_status === "AT_RISK",
        })}
        variant="error"
        icon="FeatherAlertTriangle"
      >
        At Risk
      </CustomBadge>
      <CustomBadge
        className={SubframeCore.twClassNames("hidden", {
          flex: !is_active,
        })}
        variant="error"
        icon="FeatherUserX"
      >
        Terminated
      </CustomBadge>
    </div>
  );
};

export default EmployeeSearchResultItemV2;
